// src/pages/CommercialsPage.js
import React, { useState } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import PageHeader from "../components/ui/PageHeader";
import CommercialList from "../components/commercials/CommercialList";
import CommercialForm from "../components/commercials/CommercialForm";
import CommercialDetail from "../components/commercials/CommercialDetail";
import { Box, Button, Dialog, DialogContent, useTheme } from "@mui/material";
import { Add } from "@mui/icons-material";

const CommercialsPage = () => {
  const { commercialId } = useParams();
  const navigate = useNavigate();
  const theme = useTheme();
  const [showForm, setShowForm] = useState(false);
  const [editingCommercial, setEditingCommercial] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams.get("new") === "true") {
      setShowForm(true);
    }
  }, []);

  const handleView = (commercial) => {
    navigate(`/commercials/${commercial.id}`);
  };

  const handleEdit = (commercial) => {
    setEditingCommercial(commercial);
    setShowForm(true);
  };

  const handleSave = () => {
    setShowForm(false);
    setEditingCommercial(null);
    setRefreshKey((k) => k + 1);
  };

  if (commercialId) {
    return <CommercialDetail commercialId={commercialId} onEdit={handleEdit} />;
  }

  return (
    <Box>
      <PageHeader
        title="Comerciales"
        action={
          <Button
            variant="contained"
            startIcon={<Add />}
            onClick={() => {
              setEditingCommercial(null);
              setShowForm(true);
            }}
            sx={{
              background: `linear-gradient(135deg, ${theme.palette.info.main} 0%, ${theme.palette.info.dark} 100%)`,
              borderRadius: "12px",
              textTransform: "none",
              fontWeight: 600,
              boxShadow: 'none',
              '&:hover': {
                boxShadow: `0 4px 12px ${theme.palette.info.main}40`,
                filter: 'brightness(1.05)',
              },
            }}
          >
            Nuevo Comercial
          </Button>
        }
      />
      <CommercialList key={refreshKey} onView={handleView} onEdit={handleEdit} />

      <Dialog
        key={editingCommercial?.id || "new"}
        open={showForm}
        onClose={() => {
          setShowForm(false);
          setEditingCommercial(null);
        }}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "24px",
            maxHeight: "90vh",
          },
        }}
      >
        <DialogContent sx={{ p: 0 }}>
          <CommercialForm
            commercial={editingCommercial}
            onSave={handleSave}
            onCancel={() => {
              setShowForm(false);
              setEditingCommercial(null);
            }}
          />
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default CommercialsPage;